export enum BoardViewEnum {
  HOLISTIC_VIEW = "holistic",
  KANBAN_VIEW = "kanban",
  LIST_VIEW = "list",
  GRID_VIEW = "grid",
}
